import { createSlice } from "@reduxjs/toolkit";
import GetQrLink from "../requests/getQrLink";
import { getPropertiesEntry } from "../requests";

const getQrLinkSlice = createSlice({
  name: "post",
  initialState: {
    id: null,
    link: "",
    status: null,
    hash: null,
    error: null,
    errorFile: null,
  },
  reducers: {
    setId(state, { payload }) {
      state.id = payload;
    },
    setLink(state, { payload }) {
      state.link = payload;
    },
    setHash(state, { payload }) {
      state.hash = payload;
    },
    setError(state, { payload }) {
      state.error = payload;
    },
    setErrorFile(state, { payload }) {
      state.errorFile = payload;
    },
  },
  extraReducers: {
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      state.id = payload.data.id;
      state.link = payload.data.link;
      state.hash = payload.data.hash;
      state.status = "success";
    },
    [GetQrLink.pending]: (state) => {
      state.status = "load";
      state.error = null;
      state.errorFile = null;
    },
    [GetQrLink.fulfilled]: (state, { payload }) => {
      state.id = payload?.id || null;
      state.link = payload?.url || "";
      state.hash = payload?.hash || null;
      state.error = payload?.error || null;
      state.status = !!payload?.error ? "failed" : "success";
      state.errorFile = payload?.errorFileSize || null;
    },
    [GetQrLink.rejected]: (state, { payload }) => {
      state.status = "failed";
      state.error = payload?.error || payload || null;
      state.errorFile = payload?.errorFileSize || null;
    },
  },
});
export const { setId, setLink, setHash, setError, setErrorFile } =
  getQrLinkSlice.actions;
export default getQrLinkSlice.reducer;
